import { CustomError } from "./CustomError";

/**
 * In practice this is meant to wrap `TypeError: Failed to fetch` (chrome)
 * or `TypeError: NetworkError when attempting to fetch resource.` (firefox)
 */
export class NetworkFetchError extends CustomError {}
